




















import Vue from 'vue';
import Component from 'vue-class-component';
import MCarousel from '../../index';

Vue.use(MCarousel);
@Component({
  name: 'Demo1'
})
export default class Demo1 extends Vue {
  public data = ['AiyWuByWklrrUDlFignR', 'TekJlZRVCjLFexlOCuWn', 'IJOtIlfsYdTyaDTRVrLI'];

  public load() {
    // fire window resize event to change height
    window.dispatchEvent(new Event('resize'));
  }
}
